export const VARIANT_COMBO = '5419b6ffb0d04a076446a9af'
export const VARIANT_STAR = '5419b732fbfb950b10de65e5'
